import { render, staticRenderFns } from "./role-detail.vue?vue&type=template&id=08f435b6&scoped=true&"
import script from "./role-detail.vue?vue&type=script&lang=js&"
export * from "./role-detail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=08f435b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f435b6",
  null
  
)

component.options.__file = "role-detail.vue"
export default component.exports